import { ButtonProps } from '@mui/material';

import { StyledButton } from './styles';

export type TButton = ButtonProps;

export const Button = ({
  size = 'medium',
  disableFocusRipple = true,
  disableRipple = true,
  variant = 'text',
  ...otherProps
}: TButton) => {
  return (
    <StyledButton
      size={size}
      disableFocusRipple={disableFocusRipple}
      disableRipple={disableRipple}
      variant={variant}
      {...otherProps}
    />
  );
};
